<sp-timer
    class="sp-timer-root"
    [classes]="classes"
    [timerId]="getWidgetId(widget)"
    [timerData]="widgetData"
></sp-timer>
